import React, { createContext, useState } from 'react';

import { useContextSafe } from 'helpers/utils';

import { ApiClient } from './codegen/api';
import middlewares from './middlewares';

const PublicApiContext = createContext<ApiClient | null>(null);
const usePublicApi = () => useContextSafe(PublicApiContext);

type ApiProviderProps = {
  children: React.ReactNode;
  showErrorToasts?: boolean;
};

function PublicApiProvider({ children, showErrorToasts = true }: ApiProviderProps) {
  const [api] = useState(
    () =>
      new ApiClient({
        baseUrl: `${window.location.origin}/api/internal/public`,
        middlewares: [
          new middlewares.AddCsrfHeaderMiddleware(),
          ...(showErrorToasts ? [new middlewares.HandleErrorsMiddleware()] : []),
        ],
        getHeaders: () => ({
          'Accept-Language': window.appState.lang,
          'Content-Type': 'application/json',
          'X-Retino-Frontend': window.appState.bundleHash,
        }),
      }),
  );

  return <PublicApiContext.Provider value={api}>{children}</PublicApiContext.Provider>;
}

export { PublicApiContext, PublicApiProvider };
export default usePublicApi;
